// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3eRAo","newExpiryDate":"styles_newExpiryDate__2BPcP","footer":"styles_footer__3Fxir"};